import { Slide, Snackbar } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import { ERROR_SNACKBAR_DURATION } from "../../config";
import { generalStore } from "../../stores/GeneralStore";

const SlideTransition = (props: any) => {
    return <Slide {...props} direction="up" />;
};

export const ErrorSnackBar = observer(() => {
    const handleClose = (event: any, reason: "timeout" | "clickaway") => {
        if (reason !== "clickaway") {
            generalStore.popError();
        }
    };

    let prefix = "";
    if (generalStore.error?.error?.statusCode) {
        prefix = `${generalStore.error.error.statusCode}: `;
    }

    let postfix = "";
    if (generalStore.error?.error?.message) {
        postfix = ` (${generalStore.error?.error?.message})`;
    }

    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={!!generalStore.error}
            key={generalStore.error?.message}
            onClose={handleClose}
            autoHideDuration={ERROR_SNACKBAR_DURATION}
            message={`${prefix}${generalStore.error?.message}${postfix}`}
            TransitionComponent={SlideTransition}
            data-id="error_alert"
        />
    );
});
